import { TriangleAlert } from "lucide-react";

interface AvisoConflitoProps {
  /** Nomes de quem já tem outra escala no mesmo horário. Não bloqueia — só avisa (arquitetura §12/§17: conflito nunca vira erro). */
  nomesComConflito: string[];
}

/** Aviso não bloqueante pós-`escala_verificar_conflito` — nunca impede a inclusão. */
export function AvisoConflito({ nomesComConflito }: AvisoConflitoProps) {
  if (nomesComConflito.length === 0) return null;

  return (
    <div className="flex items-start gap-2 rounded-md bg-warning/10 px-3 py-2.5 text-xs text-warning">
      <TriangleAlert size={15} className="mt-0.5 shrink-0" />
      <p>
        <span className="font-semibold">Conflito de horário:</span>{" "}
        {nomesComConflito.join(", ")} já {nomesComConflito.length === 1 ? "está escalado(a)" : "estão escalados(as)"}{" "}
        em outra escala neste mesmo horário. Você ainda pode escalar — é só um aviso.
      </p>
    </div>
  );
}
